import { MutationOptions, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ConciergeErrorResponse } from 'src/api/concierge';
import { postInspectionAction } from 'src/features/bookings/api';

import { InspectionAction } from '../components/enum/inspection-action';

export const usePostInspection = (
    action: InspectionAction,
    config?: MutationOptions<
        void,
        AxiosError<ConciergeErrorResponse>,
        { id: string; academicYear: string }
    >
) =>
    useMutation<void, AxiosError<ConciergeErrorResponse>, { id: string; academicYear: string }>({
        mutationKey: ['housekeeping', action],
        mutationFn: async ({ id, academicYear }) => postInspectionAction(id, academicYear, action),
        ...config,
    });
